import React from 'react';

const DashboardFlexRow = ({ children, gap = 24, style = {}, ...props }) => (
  <div
    style={{
      display: 'flex',
      gap,
      marginBottom: 32,
      flexWrap: 'wrap',
      ...style,
    }}
    className="dashboard-flex-row"
    {...props}
  >
    {children}
    <style>{`
      @media (max-width: 900px) {
        .dashboard-flex-row {
          flex-direction: column !important;
          gap: 16px !important;
        }
      }
      @media (max-width: 600px) {
        .dashboard-flex-row {
          gap: 8px !important;
          margin-bottom: 16px !important;
        }
      }
    `}</style>
  </div>
);

export default DashboardFlexRow; 